const HeaderSimple = () => {
	const block = document.querySelector(".header-simple");
	if (!block) {
		return;
	}
	const back = block.querySelector(".header-simple__back");
	
	back.addEventListener("click", (e) => {
		if (window.history.length > 2) {
			history.back();
		} else {
			window.location.href = '/';
		}
	});
};

export default HeaderSimple;
